import constants from '@/app-configs/constants'

export default [
  {
    path: '/email-templates',
    name: 'email-templates',
    component: () => import('@/views/templates/EmailTemplate.vue'),
    meta: {
      pageTitle: 'DEBTIA_EMAIL_TEMPLATE',
      breadcrumb: [
        {
          text: 'DEBTIA_EMAIL_TEMPLATE',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
  {
    path: '/sms-templates',
    name: 'sms-templates',
    component: () => import('@/views/templates/SmsTemplate.vue'),
    meta: {
      pageTitle: 'DEBTIA_SMS_TEMPLATE',
      breadcrumb: [
        {
          text: 'DEBTIA_SMS_TEMPLATE',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
